const NotFound = () => {
    return (
        <div className='not-found'>
            <h1 data-text="404">404</h1><h3 data-text="Page Not Found">Page Not Found</h3>
        </div>
    )
}

export default NotFound
